import React from 'react';

import {Button} from 'reactstrap';

const LocaleSwitcher:React.FC<{
  locale: string;
  setLocale: (arg0:string) => void;
}> = ({locale, setLocale}) => {
  return (
    <div className="locale-container">
      <Button color="link" onClick={() => setLocale('fr')} className={locale === 'fr' ? 'active-locale' : ''}>
        <img
          alt="French"
          src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/fr.png"
        />
            &nbsp;FR
          </Button>
      <Button color="link" onClick={() => setLocale('en')} className={locale === 'en' ? 'active-locale' : ''}>
        <img
          alt="English"
          src="https://www.e-slides.net/wp-content/plugins/wpglobus/flags/us.png"
        />
            &nbsp;EN
          </Button>
    </div>
  )
}

export default LocaleSwitcher;